import browserLang from "browser-lang";

import {i18n} from "@/main";
import {DEFAULT_LANGUAGE, Languages} from "@/constants/locale";
import VueI18n from "vue-i18n";

export const getBrowserLanguage = (): Languages => {
  // @ts-ignore
  return browserLang({
    languages: [Languages.es, Languages.ca, Languages.en],
    fallback: DEFAULT_LANGUAGE,
  }) as Languages;
};

export const setI18nLanguage = (lang: Languages) => {
  i18n.locale = lang;
};

export const getI18nLanguage = (): Languages => {
  return i18n ? i18n.locale  as Languages
              : getBrowserLanguage();
};

export const translateString = (myText: string): string => {
  return i18n.tc(myText);
};

export const translateStringWithParams = (myText: string, myParams: any): VueI18n.TranslateResult => {
  return i18n.t(myText, myParams);
};

